import { observer } from 'mobx-react';
import * as React from 'react';
import CurrentCollectionStep from './CurrentCollectionStep';
import PublishingReactions from './Edit/CurrentCollectionStep/Share/PublishSection/Store/Reactions';
import LearningDesignsReactions from './LearningDesigns/Reactions';
import LearningCollectionReactions from './Reactions';
import LearningCollectionStore from './Store';
import ProductLicensesReactions from './ProductLicenses/Reactions';
import { nothing } from 'maybeasy';

interface Props {
  store: LearningCollectionStore;
}

class LearningCollection extends React.Component<Props, {}> {
  render() {
    const { store } = this.props;
    return (
      <>
        <CurrentCollectionStep store={store} />
        <LearningCollectionReactions store={store} />
        <PublishingReactions store={store.publishingStore} />
        <LearningDesignsReactions store={store.learningDesignsStore} />
        <ProductLicensesReactions
          store={store.productLicensesStore}
          learningCollectionId={nothing()}
        />
      </>
    );
  }
}

export default observer(LearningCollection);
